import type { AuthClient } from '../client'

export const idErrorMessage: Record<keyof AuthClient['$ERROR_CODES'], string> = {
  // Base error codes
  USER_NOT_FOUND: 'Pengguna tidak ditemukan',
  FAILED_TO_CREATE_USER: 'Gagal membuat pengguna',
  FAILED_TO_CREATE_SESSION: 'Gagal membuat sesi',
  FAILED_TO_UPDATE_USER: 'Gagal memperbarui pengguna',
  FAILED_TO_GET_SESSION: 'Gagal mengambil sesi',
  INVALID_PASSWORD: 'Kata sandi tidak valid',
  INVALID_EMAIL: 'Email tidak valid',
  INVALID_EMAIL_OR_PASSWORD: 'Email atau kata sandi tidak valid',
  SOCIAL_ACCOUNT_ALREADY_LINKED: 'Akun sosial sudah terhubung',
  PROVIDER_NOT_FOUND: 'Provider tidak ditemukan',
  INVALID_TOKEN: 'Token tidak valid',
  ID_TOKEN_NOT_SUPPORTED: 'id_token tidak didukung',
  FAILED_TO_GET_USER_INFO: 'Gagal mengambil informasi pengguna',
  USER_EMAIL_NOT_FOUND: 'Email pengguna tidak ditemukan',
  EMAIL_NOT_VERIFIED: 'Email belum diverifikasi',
  PASSWORD_TOO_SHORT: 'Kata sandi terlalu pendek',
  PASSWORD_TOO_LONG: 'Kata sandi terlalu panjang',
  USER_ALREADY_EXISTS: 'Pengguna sudah terdaftar.',
  USER_ALREADY_EXISTS_USE_ANOTHER_EMAIL: 'Pengguna sudah terdaftar. Gunakan email lain.',
  EMAIL_CAN_NOT_BE_UPDATED: 'Email tidak dapat diperbarui',
  CREDENTIAL_ACCOUNT_NOT_FOUND: 'Akun kredensial tidak ditemukan',
  SESSION_EXPIRED: 'Sesi kedaluwarsa. Masuk kembali untuk melakukan tindakan ini.',
  FAILED_TO_UNLINK_LAST_ACCOUNT: 'Kamu tidak dapat memutus akun terakhir',
  ACCOUNT_NOT_FOUND: 'Akun tidak ditemukan',
  USER_ALREADY_HAS_PASSWORD: 'Pengguna sudah memiliki kata sandi. Berikan kata sandi untuk menghapus akun.',
  CROSS_SITE_NAVIGATION_LOGIN_BLOCKED:
    'Login navigasi lintas situs diblokir. Permintaan ini tampak seperti serangan CSRF.',
  VERIFICATION_EMAIL_NOT_ENABLED: 'Email verifikasi tidak diaktifkan',
  EMAIL_ALREADY_VERIFIED: 'Email sudah diverifikasi',
  EMAIL_MISMATCH: 'Email tidak cocok',
  SESSION_NOT_FRESH: 'Sesi tidak valid',
  LINKED_ACCOUNT_ALREADY_EXISTS: 'Akun terhubung sudah ada',
  INVALID_ORIGIN: 'Asal tidak valid',
  INVALID_CALLBACK_URL: 'Callback URL tidak valid',
  INVALID_REDIRECT_URL: 'Redirect URL tidak valid',
  INVALID_ERROR_CALLBACK_URL: 'Error callback URL tidak valid',
  INVALID_NEW_USER_CALLBACK_URL: 'Callback pengguna baru tidak valid',
  MISSING_OR_NULL_ORIGIN: 'Origin hilang atau kosong',
  CALLBACK_URL_REQUIRED: 'Callback URL wajib diisi',
  FAILED_TO_CREATE_VERIFICATION: 'Tidak dapat membuat verifikasi',
  FIELD_NOT_ALLOWED: 'Bidang tidak diizinkan untuk diatur',
  ASYNC_VALIDATION_NOT_SUPPORTED: 'Validasi async tidak didukung',
  VALIDATION_ERROR: 'Kesalahan validasi',
  MISSING_FIELD: 'Field wajib diisi',

  // Admin plugin
  BANNED_USER: 'Kamu telah diblokir dari aplikasi ini',
  YOU_CANNOT_BAN_YOURSELF: 'Kamu tidak dapat memblokir dirimu sendiri',
  YOU_ARE_NOT_ALLOWED_TO_CHANGE_USERS_ROLE: 'Kamu tidak diizinkan mengubah peran pengguna',
  YOU_ARE_NOT_ALLOWED_TO_CREATE_USERS: 'Kamu tidak diizinkan membuat pengguna',
  YOU_ARE_NOT_ALLOWED_TO_LIST_USERS: 'Kamu tidak diizinkan melihat daftar pengguna',
  YOU_ARE_NOT_ALLOWED_TO_LIST_USERS_SESSIONS: 'Kamu tidak diizinkan melihat sesi pengguna',
  YOU_ARE_NOT_ALLOWED_TO_BAN_USERS: 'Kamu tidak diizinkan memblokir pengguna',
  YOU_ARE_NOT_ALLOWED_TO_IMPERSONATE_USERS: 'Kamu tidak diizinkan menyamar sebagai pengguna',
  YOU_ARE_NOT_ALLOWED_TO_REVOKE_USERS_SESSIONS: 'Kamu tidak diizinkan mencabut sesi pengguna',
  YOU_ARE_NOT_ALLOWED_TO_DELETE_USERS: 'Kamu tidak diizinkan menghapus pengguna',
  YOU_ARE_NOT_ALLOWED_TO_SET_USERS_PASSWORD: 'Kamu tidak diizinkan mengatur kata sandi pengguna',
  YOU_ARE_NOT_ALLOWED_TO_GET_USER: 'Kamu tidak diizinkan melihat pengguna',
  NO_DATA_TO_UPDATE: 'Tidak ada data untuk diperbarui',
  YOU_ARE_NOT_ALLOWED_TO_UPDATE_USERS: 'Kamu tidak diizinkan memperbarui pengguna',
  YOU_CANNOT_REMOVE_YOURSELF: 'Kamu tidak dapat menghapus dirimu sendiri',
  YOU_ARE_NOT_ALLOWED_TO_SET_NON_EXISTENT_VALUE: 'Kamu tidak diizinkan mengatur nilai peran yang tidak ada',
  YOU_CANNOT_IMPERSONATE_ADMINS: 'Kamu tidak dapat menyamar sebagai admin',
  INVALID_ROLE_TYPE: 'Tipe peran tidak valid',

  // Organization plugin
  YOU_ARE_NOT_ALLOWED_TO_CREATE_A_NEW_ORGANIZATION: 'Kamu tidak diizinkan membuat organisasi baru',
  YOU_HAVE_REACHED_THE_MAXIMUM_NUMBER_OF_ORGANIZATIONS: 'Kamu telah mencapai batas maksimal organisasi',
  ORGANIZATION_ALREADY_EXISTS: 'Organisasi sudah ada',
  ORGANIZATION_SLUG_ALREADY_TAKEN: 'Slug organisasi sudah digunakan',
  ORGANIZATION_NOT_FOUND: 'Organisasi tidak ditemukan',
  USER_IS_NOT_A_MEMBER_OF_THE_ORGANIZATION: 'Pengguna bukan anggota organisasi ini',
  YOU_ARE_NOT_ALLOWED_TO_UPDATE_THIS_ORGANIZATION: 'Kamu tidak diizinkan memperbarui organisasi ini',
  YOU_ARE_NOT_ALLOWED_TO_DELETE_THIS_ORGANIZATION: 'Kamu tidak diizinkan menghapus organisasi ini',
  NO_ACTIVE_ORGANIZATION: 'Tidak ada organisasi aktif',
  USER_IS_ALREADY_A_MEMBER_OF_THIS_ORGANIZATION: 'Pengguna sudah menjadi anggota organisasi ini',
  MEMBER_NOT_FOUND: 'Anggota tidak ditemukan',
  ROLE_NOT_FOUND: 'Peran tidak ditemukan',
  YOU_ARE_NOT_ALLOWED_TO_CREATE_A_NEW_TEAM: 'Kamu tidak diizinkan membuat tim baru',
  TEAM_ALREADY_EXISTS: 'Tim sudah ada',
  TEAM_NOT_FOUND: 'Tim tidak ditemukan',
  YOU_CANNOT_LEAVE_THE_ORGANIZATION_AS_THE_ONLY_OWNER:
    'Kamu tidak dapat keluar sebagai satu-satunya pemilik organisasi',
  YOU_CANNOT_LEAVE_THE_ORGANIZATION_WITHOUT_AN_OWNER: 'Kamu tidak dapat keluar tanpa meninggalkan pemilik organisasi',
  YOU_ARE_NOT_ALLOWED_TO_DELETE_THIS_MEMBER: 'Kamu tidak diizinkan menghapus anggota ini',
  YOU_ARE_NOT_ALLOWED_TO_INVITE_USERS_TO_THIS_ORGANIZATION:
    'Kamu tidak diizinkan mengundang pengguna ke organisasi ini',
  USER_IS_ALREADY_INVITED_TO_THIS_ORGANIZATION: 'Pengguna sudah diundang ke organisasi ini',
  INVITATION_NOT_FOUND: 'Undangan tidak ditemukan',
  YOU_ARE_NOT_THE_RECIPIENT_OF_THE_INVITATION: 'Kamu bukan penerima undangan ini',
  EMAIL_VERIFICATION_REQUIRED_BEFORE_ACCEPTING_OR_REJECTING_INVITATION:
    'Verifikasi email diperlukan sebelum menerima atau menolak undangan',
  YOU_ARE_NOT_ALLOWED_TO_CANCEL_THIS_INVITATION: 'Kamu tidak diizinkan membatalkan undangan ini',
  INVITER_IS_NO_LONGER_A_MEMBER_OF_THE_ORGANIZATION: 'Pengundang sudah bukan anggota organisasi',
  YOU_ARE_NOT_ALLOWED_TO_INVITE_USER_WITH_THIS_ROLE: 'Kamu tidak diizinkan mengundang pengguna dengan peran ini',
  FAILED_TO_RETRIEVE_INVITATION: 'Gagal mengambil undangan',
  YOU_HAVE_REACHED_THE_MAXIMUM_NUMBER_OF_TEAMS: 'Kamu telah mencapai batas maksimal tim',
  UNABLE_TO_REMOVE_LAST_TEAM: 'Tidak dapat menghapus tim terakhir',
  YOU_ARE_NOT_ALLOWED_TO_UPDATE_THIS_MEMBER: 'Kamu tidak diizinkan memperbarui anggota ini',
  ORGANIZATION_MEMBERSHIP_LIMIT_REACHED: 'Batas keanggotaan organisasi tercapai',
  YOU_ARE_NOT_ALLOWED_TO_CREATE_TEAMS_IN_THIS_ORGANIZATION: 'Kamu tidak diizinkan membuat tim di organisasi ini',
  YOU_ARE_NOT_ALLOWED_TO_DELETE_TEAMS_IN_THIS_ORGANIZATION: 'Kamu tidak diizinkan menghapus tim di organisasi ini',
  YOU_ARE_NOT_ALLOWED_TO_UPDATE_THIS_TEAM: 'Kamu tidak diizinkan memperbarui tim ini',
  YOU_ARE_NOT_ALLOWED_TO_DELETE_THIS_TEAM: 'Kamu tidak diizinkan menghapus tim ini',
  INVITATION_LIMIT_REACHED: 'Batas undangan tercapai',
  TEAM_MEMBER_LIMIT_REACHED: 'Batas anggota tim tercapai',
  USER_IS_NOT_A_MEMBER_OF_THE_TEAM: 'Pengguna bukan anggota tim ini',
  YOU_CAN_NOT_ACCESS_THE_MEMBERS_OF_THIS_TEAM: 'Kamu tidak diizinkan melihat anggota tim ini',
  YOU_DO_NOT_HAVE_AN_ACTIVE_TEAM: 'Kamu tidak memiliki tim aktif',
  YOU_ARE_NOT_ALLOWED_TO_CREATE_A_NEW_TEAM_MEMBER: 'Kamu tidak diizinkan membuat anggota tim baru',
  YOU_ARE_NOT_ALLOWED_TO_REMOVE_A_TEAM_MEMBER: 'Kamu tidak diizinkan menghapus anggota tim',
  YOU_ARE_NOT_ALLOWED_TO_ACCESS_THIS_ORGANIZATION: 'Kamu tidak diizinkan mengakses organisasi ini sebagai pemilik',
  YOU_ARE_NOT_A_MEMBER_OF_THIS_ORGANIZATION: 'Kamu bukan anggota organisasi ini',
  MISSING_AC_INSTANCE:
    'Dynamic Access Control memerlukan instance ac yang telah ditentukan pada plugin auth server. Baca log server untuk informasi lebih lanjut',
  YOU_MUST_BE_IN_AN_ORGANIZATION_TO_CREATE_A_ROLE: 'Kamu harus berada di organisasi untuk membuat peran',
  YOU_ARE_NOT_ALLOWED_TO_CREATE_A_ROLE: 'Kamu tidak diizinkan membuat peran',
  YOU_ARE_NOT_ALLOWED_TO_UPDATE_A_ROLE: 'Kamu tidak diizinkan memperbarui peran',
  YOU_ARE_NOT_ALLOWED_TO_DELETE_A_ROLE: 'Kamu tidak diizinkan menghapus peran',
  YOU_ARE_NOT_ALLOWED_TO_READ_A_ROLE: 'Kamu tidak diizinkan membaca peran',
  YOU_ARE_NOT_ALLOWED_TO_LIST_A_ROLE: 'Kamu tidak diizinkan melihat daftar peran',
  YOU_ARE_NOT_ALLOWED_TO_GET_A_ROLE: 'Kamu tidak diizinkan melihat peran',
  TOO_MANY_ROLES: 'Organisasi ini memiliki terlalu banyak peran',
  INVALID_RESOURCE: 'Izin yang diberikan mencakup sumber daya yang tidak valid',
  ROLE_NAME_IS_ALREADY_TAKEN: 'Nama peran sudah digunakan',
  CANNOT_DELETE_A_PRE_DEFINED_ROLE: 'Tidak dapat menghapus peran yang telah ditentukan',

  // Email OTP plugin
  OTP_EXPIRED: 'OTP kedaluwarsa',
  INVALID_OTP: 'OTP tidak valid',
  TOO_MANY_ATTEMPTS: 'Terlalu banyak percobaan',

  // Phone number plugin
  INVALID_PHONE_NUMBER: 'Nomor telepon tidak valid',
  PHONE_NUMBER_EXIST: 'Nomor telepon sudah terdaftar',
  PHONE_NUMBER_NOT_EXIST: 'Nomor telepon belum terdaftar',
  INVALID_PHONE_NUMBER_OR_PASSWORD: 'Nomor telepon atau kata sandi tidak valid',
  UNEXPECTED_ERROR: 'Terjadi kesalahan tak terduga',
  OTP_NOT_FOUND: 'OTP tidak ditemukan',
  PHONE_NUMBER_NOT_VERIFIED: 'Nomor telepon belum diverifikasi',
  PHONE_NUMBER_CANNOT_BE_UPDATED: 'Nomor telepon tidak dapat diperbarui',
  SEND_OTP_NOT_IMPLEMENTED: 'sendOTP belum diimplementasikan',

  // Switch user plugin (NO_ACTIVE_ORGANIZATION / ORGANIZATION_NOT_FOUND are shared with the organization plugin above)
  SWITCH_USER_NOT_AVAILABLE_FOR_ORGANIZATION: 'Pindah profil tidak tersedia untuk organisasi ini',
  CALLER_IS_NOT_A_MEMBER_OF_THE_ORGANIZATION: 'Kamu bukan anggota organisasi ini',
  TARGET_USER_NOT_FOUND: 'Pengguna tidak ditemukan',
  TARGET_USER_IS_NOT_A_MEMBER_OF_THE_ORGANIZATION: 'Pengguna bukan anggota organisasi ini',
  FAMILY_PIN_NOT_SET: 'PIN keluarga belum diatur',
  FAMILY_PIN_REQUIRED: 'PIN diperlukan untuk pindah ke profil orang tua',
  INVALID_FAMILY_PIN: 'PIN tidak valid',
  PARENT_PASSWORD_REQUIRED: 'Kata sandi orang tua diperlukan untuk membuka dasbor orang tua',
  PARENT_HAS_NO_PASSWORD: 'Akun orang tua ini belum punya kata sandi. Atur PIN orang tua lebih dulu, ya.',
  INVALID_PARENT_PASSWORD: 'Kata sandi tidak valid',
  SCHOOL_SWITCH_CALLER_MUST_BE_STUDENT: 'Hanya siswa yang bisa pindah profil di sekolah',
  SCHOOL_SWITCH_TARGET_MUST_BE_STUDENT: 'Di sekolah kamu hanya bisa pindah ke profil siswa lain',
  STUDENT_PIN_NOT_SET: 'Siswa ini belum punya PIN',
  STUDENT_PIN_REQUIRED: 'PIN siswa diperlukan',
  INVALID_STUDENT_PIN: 'PIN siswa tidak valid',
}
